Ext.define('SA.view.NewView2List', {
    alias: 'widget.new-view-list',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-new-view-list',

    tpl: [
        '<tpl for=".">',
            '<div class="sa-new-view-list-item <tpl if="disabled">sa-new-view-list-item-disabled</tpl>">',
                '<div class="sa-new-view-list-item-header">',
                    '<svg class="sa-new-view-list-icon"><use href="#{icon}"></use></svg>',
                    '{title:htmlEncode}',
                '</div>',
                '<div class="sa-new-view-list-description">{description:htmlEncode}</div>',
                '<button data-type="{type}" class="sa-button sa-button-default sa-new-view-list-button">',
                    '<span class="sa-button-text">Create</span>',
                '</button>',
            '</div>',
        '</tpl>'
    ],

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-new-view-list-button',

            click: (ev, target) => this.fireEvent('click:createView', {type: target.getAttribute('data-type')}),
            mousedown: (ev, target) => Ext.fly(target).addCls('sa-button-active'),
            mouseover: (ev, target) => Ext.fly(target).addCls('sa-button-over'),
            mouseup: (ev, target) => Ext.fly(target).removeCls('sa-button-active'),

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-button-active');
                Ext.fly(target).removeCls('sa-button-over');
            }
        });
    }
});